/** Animated shimmer bar used in skeletons */
function Shimmer({ className }: { className: string }) {
  return (
    <div
      className={`animate-pulse rounded-lg bg-white/[0.05] ${className}`}
    />
  );
}

/** Generic dashboard page skeleton — used while config is loading */
export default function PageSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-6 max-w-4xl animate-fade-in">
      {/* Header row */}
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Shimmer className="h-7 w-48" />
          <Shimmer className="h-4 w-72" />
        </div>
        <Shimmer className="h-10 w-32" />
      </div>

      {/* Tab bar */}
      <Shimmer className="h-12 w-full" />

      {/* Content cards */}
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="bg-dark-800/40 border border-white/[0.04] rounded-2xl p-6 space-y-4"
        >
          <div className="flex items-center justify-between">
            <div className="space-y-2">
              <Shimmer className="h-5 w-40" />
              <Shimmer className="h-3.5 w-64" />
            </div>
            <Shimmer className="h-8 w-12 rounded-full" />
          </div>
          {i === 0 && (
            <div className="space-y-3 pt-2">
              <Shimmer className="h-10 w-full" />
              <Shimmer className="h-24 w-full" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
